<template>
  <div>
    <NavBar />
    <AuthBySessionExpired />
    <div class="container">
      <div class="row">
        <div class="col-xl-1 col-lg-2 col-md-2 col-sm-3 col-12">
          <v-btn class="btn-return" @click="handleToBack">
            <i class="fas fa-arrow-left mr-2 text-twenty"></i> VOLTAR
          </v-btn>
        </div>
        <div class="col-xl-11 col-lg-10 col-md-10 col-sm-9 col-12">
          <h1 class="title-pages mt-1">PRODUTO: {{ name }}</h1>
          <h6>
            TIPO:
            {{ type == "CASA_DE_REPOUSO" ? "EMPRESA" : "PADRÃO" }}
          </h6>
        </div>
      </div>
      <b-overlay :show="loading" opacity="0.99">
        <form @submit.prevent="evOnSubmit">
          <WarningMessage
            v-if="!permission('edit', 'product')"
            message="Você não tem permissão para modificar produtos"
          />
          <WarningMessage
            v-if="type == 'PADRAO'"
            message="ESTE PRODUTO É PADRÃO, POR ISSO NÃO PODE SER ALTERADO QUAISQUER INFORMAÇÕES!"
          />
          <div class="row">
            <div
              class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 pt-0 pb-0"
            >
              <LabelRequiredField label="NOME" />
              <input
                :disabled="!permission('edit', 'product') || type == 'PADRAO'"
                type="text"
                ref="autofocus"
                v-model="name"
                class="form-control"
              />
            </div>
            <div class="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-12 pt-0 pb-0">
              <LabelRequiredField label="UNIDADE DE MEDIDA" />
              <select
                :disabled="!permission('edit', 'product') || type == 'PADRAO'"
                v-model="unit_of_measurement_id"
                class="form-control"
              >
                <option
                  v-for="unit in units_of_measurement"
                  :key="unit.id"
                  :value="unit.id"
                >
                  {{ `${unit.name} (${unit.abbreviation})` }}
                </option>
              </select>
            </div>
            <div class="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-12 pt-0 pb-0">
              <label>ESTOQUE MÍNIMO</label>
              <input
                :disabled="!permission('edit', 'product') || type == 'PADRAO'"
                type="text"
                v-model="minimum_stock"
                class="form-control"
              />
            </div>
            <div
              v-if="type == 'CASA_DE_REPOUSO'"
              class="col-md-12 pt-0 pb-0"
            ></div>
            <div
              v-if="type == 'CASA_DE_REPOUSO'"
              class="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12 pt-0 pb-0"
            >
              <label>CUSTO DO PRODUTO</label>
              <input
                :disabled="!permission('edit', 'product') || type == 'PADRAO'"
                type="text"
                v-model="product_cost"
                class="form-control"
                @keyup="handleValueProductCost"
              />
            </div>
            <div
              v-if="type == 'CASA_DE_REPOUSO'"
              class="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12 pt-0 pb-0"
            >
              <label>LUCRO(%)</label>
              <input
                :disabled="!permission('edit', 'product') || type == 'PADRAO'"
                type="text"
                @keyup="handleValueProfit"
                v-model="profit"
                class="form-control"
              />
            </div>
            <div
              v-if="type == 'CASA_DE_REPOUSO'"
              class="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12 pt-0 pb-0"
            >
              <label>VALOR DA VENDA</label>
              <input
                :disabled="!permission('edit', 'product') || type == 'PADRAO'"
                type="text"
                v-model="sale_price"
                class="form-control"
                @keyup="handleValueSalePrice"
              />
            </div>
            <div class="col-md-12">
              <ErrorsMessages :errors="errors" />
            </div>
            <div class="col-md-12 pt-0 pb-0">
              <h6 class="mb-0 worksansr">
                Criação:
                {{ formatDate(created_at) }}
              </h6>
              <h6 class="mb-0 worksansr">
                Última alteração:
                {{ formatDate(updated_at) }}
              </h6>
            </div>
            <div class="col-md-12 text-right pt-0 pb-0">
              <v-btn
                v-if="
                  permission('edit', 'product') && type == 'CASA_DE_REPOUSO'
                "
                :disabled="loading"
                type="submit"
                class="btn-save"
              >
                <i class="fas fa-save mr-2 text-twenty"></i>
                {{ loading ? "CARREGANDO" : "SALVAR" }}
              </v-btn>
            </div>
          </div>
        </form>
      </b-overlay>
    </div>
  </div>
</template>

<script>
import NavBar from "../NavBar";
import AuthBySessionExpired from "../Components/AuthBySessionExpired";
import ErrorsMessages from "../Components/ErrorsMessages";
import LabelRequiredField from "../Components/LabelRequiredField";

import api from "../../services/api";

import toast from "../../lib/ToastNotification";

import permission from "../../lib/permission";

import {
  formatDate,
  formatPrice,
  formatValueOnKeyUp,
  formatValueToOnlyNumber,
  formatValueToPercentage,
} from "../../lib/format";

import routes from "../../routes";

export default {
  name: "ViewProduct",
  components: {
    NavBar,
    AuthBySessionExpired,
    ErrorsMessages,
    LabelRequiredField,
  },
  data: () => ({
    errors: [],
    loading: false,

    units_of_measurement: [],

    id: "",
    type: "",
    unit_of_measurement_id: "",
    name: "",
    minimum_stock: "",
    product_cost: "",
    profit: "",
    sale_price: "",
    updated_at: "",
    created_at: "",
  }),

  created() {
    this.retrieve();
  },

  methods: {
    permission,
    /** imports */
    formatDate,
    formatValueOnKeyUp,
    formatValueToOnlyNumber,
    formatValueToPercentage,

    /** eventos */
    handleToBack: () => routes.go(-1),

    async retrieve() {
      let { id } = routes.currentRoute.params;

      if (!id) {
        return routes.go(-1);
      }

      this.id = id;
      this.type = "CASA_DE_REPOUSO";

      await this.get();
      await this.getUnitsOfMeasurement();
    },

    async evOnSubmit() {
      try {
        this.loading = true;

        let {
          id,
          unit_of_measurement_id,
          name,
          minimum_stock,
          product_cost,
          profit,
          sale_price,
        } = this;

        const data = {
          id,
          unit_of_measurement_id,
          name,
          minimum_stock,
          product_cost,
          profit,
          sale_price,
        };

        const response = await api.put("/rest-home/product/update", data);

        const { error, errors, message } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          toast(message, "success");
          this.$bvModal.hide("view_product");
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },

    /** parsers */
    async get() {
      try {
        this.loading = true;

        let { id } = this;

        const params = { id };

        const response = await api.get("/rest-home/product/get", { params });

        const { error, errors, product } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.unit_of_measurement_id = product.unit_of_measurement_id;
          this.name = product.name;
          this.minimum_stock = product.minimum_stock;
          this.product_cost = formatPrice(product.product_cost);
          this.profit = product.profit;
          this.sale_price = formatPrice(product.sale_price);
          this.updated_at = product.updated_at;
          this.created_at = product.created_at;
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },

    async getUnitsOfMeasurement() {
      try {
        this.loading = true;

        const response = await api.get("/units-of-measurement/from-products");

        const { error, errors, units_of_measurement } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.units_of_measurement = units_of_measurement;
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },

    /** métodos */
    handleValueProfit: function (e) {
      let profit = formatValueToPercentage(e.target.value);
      if (profit) {
        let current = formatValueToOnlyNumber(this.product_cost);
        let percentage = profit * current;
        let sale_price = percentage / 100;
        sale_price = parseFloat(sale_price) + parseFloat(current);
        this.sale_price = formatPrice(sale_price);
      } else {
        this.sale_price = formatPrice(0);
      }
    },
    handleValueProductCost: function (e) {
      this.product_cost = formatValueOnKeyUp(e.target.value);

      let current = formatValueToOnlyNumber(e.target.value);
      let sale_price = formatValueToOnlyNumber(this.sale_price);

      if (parseInt(current) <= parseInt(sale_price)) {
        let percentage = parseFloat(sale_price - current);
        let profit = percentage * 100;
        profit = profit / current;
        profit = String(profit);
        this.profit = String(profit).replace(".", ",");
      }
    },
    handleValueSalePrice: function (e) {
      this.sale_price = formatValueOnKeyUp(e.target.value);

      let current = formatValueToOnlyNumber(this.product_cost);
      let sale_price = formatValueToOnlyNumber(e.target.value);

      if (parseInt(current) <= parseInt(sale_price)) {
        let percentage = parseFloat(sale_price - current);
        let profit = percentage * 100;
        profit = profit / current;
        profit = String(profit);
        this.profit = String(profit).replace(".", ",");
      }
    },
  },
};
</script>

<style></style>
